import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssessmentsService } from './services/assessments.service';
import { AssessmentsComponent } from './assessments/assessments.component';
import { PostAssessmentComponent } from './assessments/post-assessment.component';
import { resolveAssessments } from './assessments-resolver';
import { authGuard } from 'app/guards/auth.guard';

const routes: Routes = [
  {
    path: 'assessments',
    children: [
      {
        path: '',
        loadChildren: () => import('@upmc-healthplan-npm/assessments').then((r) => r.buildRoutes(resolveAssessments)),
      },
    ],
    component: AssessmentsComponent,
    canActivate: [authGuard, resolveAssessments],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'post-assessment',
    children: [
      {
        path: '',
        component: PostAssessmentComponent,
      },
    ],
    canActivate: [authGuard, AssessmentsService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AssessmentsRoutingModule {}
